import { render, staticRenderFns } from "./GameOfLife.vue?vue&type=template&id=00cfe486&scoped=true&"
import script from "./GameOfLife.vue?vue&type=script&lang=js&"
export * from "./GameOfLife.vue?vue&type=script&lang=js&"
import style0 from "./GameOfLife.vue?vue&type=style&index=0&id=00cfe486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cfe486",
  null
  
)

export default component.exports